
import React, {useState} from 'react'
import CartTable2 from '../../../../components/AdminTable/CartTale2'
// import Dropdown from "../../../../components/AdminDropdown/Dropdown";

function DetailedShiftReport() {
  const [columns] = useState([
    {
      header: "SN",
      accessorKey: "SN",
    
    },
   
    {
      header: "Date",
      accessorKey: "Date",
    },
    {
        header: "Time",
        accessorKey: "Time",
      },
    {
      header: "Reference ",
      accessorKey: "Reference",
    },
    {
        header: "Order Type",
        accessorKey: "Order Type",
      },
      {
        header: "Total Item",
        accessorKey: "Total Item",
      },
      {
        header: "Subtotal",
        accessorKey: "Subtotal",
      },
      {
        header: "Discount",
        accessorKey: "Discount",
      },
      {
        header: "Service/Delivry Charges",
        accessorKey: "Service/Delivry Charges",
      },
      {
        header: "Vat",
        accessorKey: "Vat",
      },
      {
        header: "G. Total",
        accessorKey: "G. Total",
      },
      {
        header: "Payment Method",
        accessorKey: "Payment Method",
      },
   
 

  ]);
  const [data] = useState([
   
  ]);
  const [buttonDataa] = useState([
   {
    buttonText: "Submit"
   }
  ]);

 const [selectButton] = useState([
  {
    placeholder: "User",
  },
 
  {
    placeholder: "Payment Method",
  },

  
  
  
 ])
  return (
    <main>
     <CartTable2
     data={data}
     columns={columns}
     heading={"Detailed Shift Report"}
     buttonDataa={buttonDataa}
     selectButton={selectButton}
     /> 
     
    </main>
  )
}

export default DetailedShiftReport
